import actions from '../../actions-list';

export const updateRgaSearchObject = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_SEARCH_MODEL_OBJECT,
    value
});

export const resetRgaSearchObjectValues = property => ({
    property,
    type: actions.RESET_RGA_SEARCH_MODEL_OBJECT_VALUES
});

export const updateRgaSearchObjectListValues = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_SEARCH_MODEL_LIST_OBJECT,
    value
});

export const resetRgaSearchObjectListValues = property => ({
    property,
    type: actions.RESET_RGA_SEARCH_MODEL_LIST_OBJECT_VALUES
});

export const resetRgaSearchObjectDateValues = property => ({
    property,
    type: actions.RESET_RGA_SEARCH_MODEL_OBJECT_DATE_VALUES
});

export const updateRgaSearchObjectDDValues = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_SEARCH_MODEL_OBJECT_DD_VALUES,
    value
});

export const resetRgaSearchModelObject = () => ({
    type: actions.RESET_RGA_SEARCH_MODEL_OBJECT
});

export const setRequestedDate = () => ({
    type: actions.SET_REQUEST_DATE_SEARCH_MODEL
});




// WEBPACK FOOTER //
// ./src/rga/search/action-creators/rga-search.js